import { IonSpinner } from "@ionic/react";

interface ILoadingProps {
  width?: string;
  height?: string;
}

function Loading({ width, height }: ILoadingProps) {
  return (
    <div
      style={{
        width: width ?? "100%",
        height: height ?? "100%",
        minHeight: "120px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "5rem 0rem",
        gap: "4px",
      }}
    >
      <span>Caricamento...</span>
      <IonSpinner style={{ "--color": "#3563b9" } as React.CSSProperties} />
    </div>
  );
}

export default Loading;
